import { render, staticRenderFns } from "./sync.vue?vue&type=template&id=e6ed2638&scoped=true&"
import script from "./sync.vue?vue&type=script&lang=js&"
export * from "./sync.vue?vue&type=script&lang=js&"
import style0 from "./sync.vue?vue&type=style&index=0&id=e6ed2638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ed2638",
  null
  
)

export default component.exports